<template>
    <div class="mainContent">
        <div class="title">
            {{proObj.title}}
            <span class="line"></span>
        </div>
        <el-row>
            <el-col :span='item.span' class="itemRow" v-for="(item,index) in proObj.list" :key='index'>
                <div class="labelText" :title='item.label'>{{item.label}}</div>
                <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'>
                    <span class="valueText unitValueText">{{item.value}}</span>
                </el-tooltip>
                <div class="valueText" v-else>{{item.value}}</div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: {
        proObj: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
<style lang="less">
.title {
    color: #333333;
    font-weight: 700;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #E4E7ED;
    margin-bottom: 15px;
}
</style>